export const seoConfig = {
  //Component (Admin Panel)
  Dashboard: {
    title: "Hirelink | Dashboard",
    description:
      "Manage jobs, candidates, interviews, employers and users easily from Hirelink admin dashboard.",
  },

  a_jobs: {
    title: "Hirelink | All Jobs",
    description:
      "View and manage all job postings, update job details, and control job status in Hirelink admin panel.",
  },

  a_candidates: {
    title: "Hirelink | All Candidates",
    description:
      "Browse all registered candidates, check profiles, manage candidate data and application activity in Hirelink.",
  },

  a_interview: {
    title: "Hirelink | All Interviews",
    description:
      "Manage interview schedules, update interview status, and track interview progress from Hirelink admin panel.",
  },

  a_applicant: {
    title: "Hirelink | All Applicants",
    description:
      "View all job applicants, track applications, and manage candidate selection using Hirelink admin tools.",
  },

  a_employers: {
    title: "Hirelink | All Employers",
    description:
      "Manage employer accounts, verify company details, and monitor employer activity in Hirelink admin dashboard.",
  },

  a_contact: {
    title: "Hirelink | All Contacts",
    description:
      "View and manage all contact queries, support requests and feedback received on Hirelink platform.",
  },

  a_user: {
    title: "Hirelink | All Users",
    description:
      "Manage all platform users, monitor account details, and control access using Hirelink admin panel.",
  },

  a_staff: {
    title: "Hirelink | Staff",
    description:
      "Manage all staff, monitor account details, and control access using Hirelink admin panel.",
  },

  emp_profile: {
    title: "Hirelink | Profile of",
    description:
      "Update your employer profile, company details and account information on Hirelink dashboard.",
  },

  a_login: {
    title: "Hirelink | Admin Login",
    description:
      "Securely login to Hirelink admin panel to manage jobs, candidates, employers and platform activity.",
  },

  a_setting: {
    title: "Hirelink | Admin Setting",
    description:
      "Securely login to Hirelink admin panel to manage jobs, candidates, employers and platform activity.",
  },

  verify: {
    title: "Hirelink | Email Verification",
    description:
      "Verify your email address to activate your Hirelink account and access platform features securely.",
  },

  //Component2 (Candidate Side)
  home: {
    title: "Pharma Jobs India 2026 | Freshers & Experienced Hiring",
    description:
      "Find latest pharma jobs in India for freshers & experienced. Apply to QA, QC, production roles. Fast hiring, verified pharma companies",
  },

  about: {
    title: "About Pharma Jobs HL | Trusted Pharma Job Portal India",
    description:
      "Learn about Pharma Jobs HL, a trusted platform connecting pharma job seekers with top companies across India. Fast, verified hiring",
  },

  contacts: {
    title: "Contact Pharma Jobs HL | Hire Candidates & Support",
    description:
      "Contact Pharma Jobs HL for hiring support, job posting, or queries. Connect with our team to recruit pharma talent faster",
  },

  c_apply: {
    title: "Hirelink | Apply Job",
    description:
      "Apply for your preferred jobs quickly and track your application status on Hirelink platform.",
  },

  companies: {
    title: "Top Pharma Companies Hiring in India 2026 | Apply Now",
    description:
      "Explore top pharma companies hiring in India. Find verified employers and apply for QA, QC, production, and R&D jobs easily",
  },

  c_contact: {
    title: "Contact Pharma Jobs HL | Pharma Hiring Support India",
    description:
      "Get in touch for pharma job support, hiring queries, or partnerships. Fast response for job seekers and pharma employers",
  },

  forgot: {
    title: "Forgot Password | Recover Pharma Jobs HL Account",
    description:
      "Reset your Pharma Jobs HL account password easily. Secure and quick recovery for job seekers",
  },

  resetpass: {
    title: "Reset Password | Hirelink",
    description:
      "Create a new password for your Hirelink account securely and continue managing your profile without interruption.",
  },

  blogs: {
    title: "Pharma Career Blogs 2026 | Jobs, Salary & Skills Guide",
    description:
      "Read latest pharma career blogs, salary insights, job trends, and skills required for pharma jobs in India. Stay updated and get hired",
  },

  help: {
    title: "Help Center | Pharma Jobs HL Support & FAQs",
    description:
      "Get help with job applications, account issues, and employer queries. Visit our pharma job support center and FAQs",
  },

  c_jobdetail: {
    title: "Hirelink | Job Details",
    description:
      "View full job details including role, requirements, salary and location before applying on Hirelink.",
  },

  c_jobs: {
    title: "Hirelink | All Jobs",
    description:
      "Browse all available jobs on Hirelink and filter by category, experience, location and preferences.",
  },

  notification: {
    title: "Hirelink | Notifications",
    description:
      "Stay updated with job alerts, application updates, interview notifications and employer messages on Hirelink.",
  },

  c_privacy: {
    title: "Privacy Policy | Pharma Jobs HL Data Protection",
    description:
      "Learn how Pharma Jobs HL protects your data. Secure, trusted platform for pharma job seekers and employers in India",
  },

  c_profile: {
    title: "Hirelink | Candidate Profile",
    description:
      "Update your candidate profile, resume, skills and personal details to get better job matches on Hirelink.",
  },

  c_return: {
    title: "Refund & Return Policy | Pharma Jobs HL Candidates",
    description:
      "Check refund and return policy for Pharma Jobs HL services. Transparent policies for candidate subscriptions and services",
  },

  signin: {
    title: "Login Pharma Jobs HL | Access Your Job Dashboard",
    description:
      "Sign in to Pharma Jobs HL to apply for jobs, track applications, and get latest pharma job alerts in India",
  },

  signup: {
    title: "Register Pharma Jobs HL | Create Free Job Account",
    description:
      "Sign up for free and apply to latest pharma jobs in India. Get instant alerts for QA, QC, production jobs",
  },

  c_term: {
    title: "Terms & Conditions | Pharma Jobs HL Candidate Policy",
    description:
      "Read terms and conditions for using Pharma Jobs HL. Understand rules, policies, and guidelines for job seekers",
  },

  //Component3 (Employer Side)
  e_employer: {
    title: "Hire Pharma Candidates | Post Jobs & Recruit Faster",
    description:
      "Hire skilled pharma candidates quickly. Post jobs, find QA, QC, production professionals, and streamline hiring",
  },

  e_employers: {
    title: "Hirelink | Employers",
    description:
      "Hire the best talent by posting jobs, managing applicants and scheduling interviews using Hirelink.",
  },

  e_privacy: {
    title: "Employer Privacy Policy | Secure Hiring Platform India",
    description:
      "Learn how employer data is protected on Pharma Jobs HL. Secure, trusted platform for pharma hiring and recruitment",
  },

  e_return: {
    title: "Employer Refund Policy | Pharma Jobs HL Services",
    description:
      "Check employer refund policy for Pharma Jobs HL. Transparent terms for job postings, hiring services, and subscriptions",
  },

  e_term: {
    title: "Employer Terms & Conditions | Pharma Jobs HL Hiring",
    description:
      "Read employer terms for Pharma Jobs HL. Understand job posting rules, hiring policies, and platform guidelines for recruiters",
  },
};
